"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var monaco = __importStar(require("monaco-editor/esm/vs/editor/editor.api"));
var monaco_editor_auto_typings_1 = require("monaco-editor-auto-typings");
var editorContents_1 = require("./editorContents");
require("./style.css");
var editor = monaco.editor.create(document.getElementById('editor-mountpoint'), {
    model: monaco.editor.createModel(editorContents_1.editorContents, 'typescript' /*Uri.parse('file://root/index.ts')*/),
});
var cache = new monaco_editor_auto_typings_1.LocalStorageCache();
monaco_editor_auto_typings_1.AutoTypings.create(editor, {
    // Cache declaration files to local storage
    sourceCache: cache,
    sourceResolver: new monaco_editor_auto_typings_1.JsDelivrSourceResolver(),
    // Log progress updates to a div console
    onUpdate: function (u, t) {
        var mountPoint = document.getElementById('logs-mountpoint');
        var log = document.createElement('div');
        log.innerHTML = t;
        mountPoint.appendChild(log);
        mountPoint.scrollTop = mountPoint.scrollHeight;
    },
    // Log errors to a div console
    onError: function (e) {
        var mountPoint = document.getElementById('logs-mountpoint');
        var log = document.createElement('div');
        log.classList.add('err');
        log.innerHTML = e;
        mountPoint.appendChild(log);
        mountPoint.scrollTop = mountPoint.scrollHeight;
    },
    // Print loaded versions to DOM
    onUpdateVersions: function (versions) {
        document.getElementById('versions-mountpoint').innerHTML = Object.entries(versions)
            .map(function (v) { return "<div>".concat(v[0], ": ").concat(v[1], "</div>"); })
            .join('');
    },
});
document.getElementById('reset-cache').onclick = function () { return cache.clear(); };
